export default "__VITE_ASSET__DDS1yIPG__"